import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Loading from '../../common/components/Loading';
import Icon from '../../common/icons/Icon';

const TIME_ZONE_ID = 'America/Phoenix';

class BookedSessionModal extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    session: PropTypes.object.isRequired,
    toggleModal: PropTypes.func.isRequired,
  };

  state = {
    canceling: false,
    cancelNote: '',
  };

  cancelSession = () => {
    this.props.onCancel(this.state);
  };

  onUpdateNote = event => {
    this.setState({
      cancelNote: event.currentTarget.value,
    });
  };

  toggleCanceling = () => {
    this.setState(state => ({ canceling: !state.canceling }));
  };

  render() {
    const { loading, session, toggleModal } = this.props;
    const { canceling, cancelNote } = this.state;

    if (loading) {
      return <Loading />;
    }

    if (canceling) {
      return (
        <div>
          <div className="booking-modal cancel-session">
            <button className="close-button" onClick={toggleModal}>
              <Icon icon="Close" />
            </button>
            <h3>Cancel Session</h3>
            <div className="booking-textarea">
              <label>Please let the requester know why you're canceling this session</label>
              <textarea value={cancelNote} onChange={this.onUpdateNote} />
            </div>
          </div>
          <div className="modal__actions">
            <button className="button button--theme--plain" type="button" onClick={this.toggleCanceling}>
              Go Back
            </button>
            <button className="button" type="button" onClick={this.cancelSession}>
              Confirm
            </button>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="booking-modal">
          <button className="close-button" onClick={toggleModal}>
            <Icon icon="Close" />
          </button>
          <div className="booking-modal--header">
            <Icon icon="Person" />
            <h3>{session.type === 'online' ? 'Online' : 'In-Person'} Follow-Up with Tathata</h3>
          </div>
          <div className="user-info">
            <div className="admin-paper__edit-content__row">
              <p>User Name</p>
              <span className="title">{session.user.name}</span>
            </div>
            <div className="admin-paper__edit-content__row">
              <p>User Email Address</p>
              <span className="title">{session.user.email}</span>
            </div>
            <div className="admin-paper__edit-content__row">
              <p>Hours</p>
              <span className="title">{session.hours}</span>
            </div>
          </div>
          {session.note && (
            <div className="booking-note">
              <i>{`"${session.note}"`}</i>
            </div>
          )}
          <div className="booking-times__wrapper" style={{ marginBottom: '0' }}>
            <p>Date & Time</p>
            <div className="booking-times">
              <strong>
                {moment(session.accepted_session_date)
                  .tz(TIME_ZONE_ID)
                  .format('MMM D, YYYY h:mmA z')}
              </strong>
            </div>
          </div>
        </div>
        {moment(session.accepted_session_date)
          .tz(TIME_ZONE_ID)
          .isAfter(
            moment()
              .tz(session.time_zone_id)
              .add(1, 'day')
          ) && (
          <div className="modal__actions">
            <div>
              <button type="button" className="button button--theme--secondary" onClick={this.toggleCanceling}>
                Cancel Session
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default BookedSessionModal;



// WEBPACK FOOTER //
// ./src/follow-ups/home/BookedSessionModal.js